export default {
  website: 'وب‌سایت',
  email: 'ایمیل',
  telegram_user: 'شناسه‌ی تلگرام',
  telegram_chanel: 'کانال تلگرام',
  instagram: 'شناسه‌ی اینستاگرام',
  aparat: 'آپارات',
  facebook: 'فیسبوک',
  linkedIn: 'لینکد‌این',
  userPhoneNumber: 'شماره‌ی تلفن جهت تماس کاربران',
  enterLinkedInUrl:
    'لطفا ادرس حساب لینکد‌این خود را به درستی وارد کنید.(https://linkdin.com/company/myCompany)',
  enterFacebookUrl:
    'لطفا ادرس حساب فیسبوک خود را به درستی وارد کنید.(https://facebook.com/myCompany)',
  enterAparatUrl:
    'لطفا ادرس حساب آپارات خود را به درستی وارد کنید.(https://www.aparat.com/myCompany)',
  enterSiteUrl:
    'لطفا ادرس وب‌سایت خود را به درستی وارد کنید.(http://mycompany.com)',
  enterTelegramId: 'لطفا شناسه‌ی تلگرام را به درستی وارد کنید.(@myComapanyId)',
  enterEmailUrl: 'لطفا ایمیل خود را به درستی وارد کنید.(contact@mycompany.com)',
  enterInstagramUrl:
    'لطفا آدرس تلگرام خود را را به درستی وارد کنید.(@myCompany)',
};
